import { render, staticRenderFns } from "./OCCheckbox.html?vue&type=template&id=04a49b72&scoped=true&"
import script from "./OCCheckbox.ts?vue&type=script&lang=ts&"
export * from "./OCCheckbox.ts?vue&type=script&lang=ts&"
import style0 from "./OCCheckbox.css?vue&type=style&index=0&id=04a49b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a49b72",
  null
  
)

export default component.exports